// Costanti di dominio COSMA TRAVEL DESK

export const STATI_TRASFERTA = [
  { value: "bozza", label: "Bozza" },
  { value: "richiesta", label: "Richiesta" },
  { value: "ricerca_in_corso", label: "Ricerca in corso" },
  { value: "soluzioni_proposte", label: "Soluzioni proposte" },
  { value: "in_approvazione", label: "In Approvazione" },
  { value: "approvata", label: "Approvata" },
  { value: "prenotata", label: "Prenotata" },
  { value: "itinerario_finale", label: "Itinerario finale" },
  { value: "annullata", label: "Annullata" },
];

export const STATO_STYLE = {
  bozza: "bg-slate-100 text-slate-700 border-slate-300",
  richiesta: "bg-sky-50 text-sky-700 border-sky-300",
  ricerca_in_corso: "bg-amber-50 text-amber-700 border-amber-300",
  soluzioni_proposte: "bg-violet-50 text-violet-700 border-violet-300",
  in_approvazione: "bg-orange-50 text-orange-700 border-orange-300",
  approvata: "bg-emerald-50 text-emerald-700 border-emerald-300",
  prenotata: "bg-teal-50 text-teal-700 border-teal-300",
  itinerario_finale: "bg-indigo-50 text-indigo-700 border-indigo-300",
  annullata: "bg-rose-50 text-rose-700 border-rose-300",
};

export const RUOLI = [
  { value: "dipendente", label: "Dipendente" },
  { value: "responsabile", label: "Responsabile" },
  { value: "amministratore", label: "Amministratore" },
];

export const STATI_PREVENTIVO = [
  { value: "preventivo", label: "Preventivo" },
  { value: "inviato", label: "Inviato" },
  { value: "approvato", label: "Approvato" },
  { value: "non_approvato", label: "Non approvato" },
  { value: "modifiche_richieste", label: "Modifiche richieste" },
];

export const MEZZI = [
  { value: "auto_aziendale", label: "Auto aziendale" },
  { value: "auto_propria", label: "Auto propria" },
  { value: "auto_noleggio", label: "Auto a noleggio" },
  { value: "treno", label: "Treno" },
  { value: "aereo", label: "Aereo" },
  { value: "bus", label: "Bus / Navetta" },
  { value: "taxi", label: "Taxi" },
  { value: "uber", label: "Uber" },
  { value: "ncc", label: "NCC" },
  { value: "trasporto_pubblico", label: "Trasporto pubblico" },
];

export const AEROPORTI_PREFERITI = [
  "Linate (LIN)",
  "Bergamo Orio al Serio (BGY)",
  "Bologna (BLQ)",
  "Verona (VRN)",
  "Malpensa (MXP)",
];

// Schemi contestuali per mezzo di trasporto
export const TRANSPORT_SCHEMAS = {
  auto_aziendale: [
    { key: "modello", label: "Modello", type: "car-select" },
    { key: "targa", label: "Targa", type: "text" },
    { key: "luogo_partenza", label: "Luogo di partenza", type: "text" },
    { key: "luogo_arrivo", label: "Luogo di arrivo", type: "text" },
    { key: "data_utilizzo", label: "Data utilizzo", type: "date" },
    { key: "ora_utilizzo", label: "Ora utilizzo", type: "time" },
    { key: "parcheggio", label: "Parcheggio", type: "text" },
    { key: "pedaggi_telepass", label: "Pedaggi / Telepass", type: "checkbox" },
    { key: "carta_carburante", label: "Carta carburante", type: "checkbox" },
    { key: "costo", label: "Costo stimato (€)", type: "number" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  auto_propria: [
    { key: "km_previsti", label: "Km previsti", type: "number" },
    { key: "rimborso_km", label: "Rimborso chilometrico (€/km)", type: "number" },
    { key: "pedaggi", label: "Pedaggi (€)", type: "number" },
    { key: "parcheggio", label: "Parcheggio", type: "text" },
    { key: "costo", label: "Costo totale (€)", type: "number" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  auto_noleggio: [
    { key: "societa", label: "Società di noleggio", type: "text" },
    { key: "luogo_ritiro", label: "Luogo di ritiro", type: "text" },
    { key: "luogo_riconsegna", label: "Luogo di riconsegna", type: "text" },
    { key: "data_ritiro", label: "Data ritiro", type: "date" },
    { key: "ora_ritiro", label: "Ora ritiro", type: "time" },
    { key: "data_riconsegna", label: "Data riconsegna", type: "date" },
    { key: "ora_riconsegna", label: "Ora riconsegna", type: "time" },
    { key: "categoria", label: "Categoria auto", type: "text" },
    { key: "cambio", label: "Cambio", type: "select", options: ["Automatico", "Manuale"] },
    { key: "conducente_aggiuntivo", label: "Conducente aggiuntivo", type: "checkbox" },
    { key: "assicurazione", label: "Assicurazione", type: "text" },
    { key: "carburante", label: "Carburante", type: "text" },
    { key: "chilometraggio", label: "Chilometraggio", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "codice_prenotazione", label: "Codice prenotazione", type: "text" },
    { key: "link", label: "Link", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  treno: [
    { key: "stazione_partenza", label: "Stazione di partenza", type: "text" },
    { key: "stazione_arrivo", label: "Stazione di arrivo", type: "text" },
    { key: "diretto", label: "Diretto", type: "checkbox" },
    { key: "cambi", label: "Eventuali cambi", type: "text" },
    { key: "orario_partenza", label: "Orario partenza", type: "time" },
    { key: "orario_arrivo", label: "Orario arrivo", type: "time" },
    { key: "classe", label: "Classe", type: "select", options: ["Standard", "Business", "Prima", "Executive"] },
    { key: "posto", label: "Posto", type: "text" },
    { key: "bagaglio", label: "Bagaglio", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "codice_prenotazione", label: "Codice prenotazione", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  aereo: [
    { key: "aeroporto_partenza", label: "Aeroporto di partenza", type: "select", options: AEROPORTI_PREFERITI, allowCustom: true },
    { key: "aeroporto_arrivo", label: "Aeroporto di arrivo", type: "text" },
    { key: "compagnia", label: "Compagnia", type: "text" },
    { key: "volo_diretto", label: "Volo diretto", type: "checkbox" },
    { key: "scalo", label: "Eventuale scalo", type: "text" },
    { key: "orario_partenza", label: "Orario partenza", type: "time" },
    { key: "orario_arrivo", label: "Orario arrivo", type: "time" },
    { key: "bagaglio_mano", label: "Bagaglio a mano", type: "checkbox" },
    { key: "bagaglio_stiva", label: "Bagaglio da stiva", type: "checkbox" },
    { key: "scelta_posto", label: "Scelta posto", type: "text" },
    { key: "checkin", label: "Check-in", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "codice_prenotazione", label: "Codice prenotazione", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  bus: [
    { key: "tipo", label: "Tipo", type: "text" },
    { key: "partenza", label: "Partenza", type: "text" },
    { key: "arrivo", label: "Arrivo", type: "text" },
    { key: "fermata", label: "Fermata", type: "text" },
    { key: "orario", label: "Orario", type: "time" },
    { key: "prenotazione", label: "Prenotazione", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "codice", label: "Codice", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ],
  taxi: TAXI_LIKE("Taxi"),
  uber: TAXI_LIKE("Uber"),
  ncc: TAXI_LIKE("NCC"),
  trasporto_pubblico: [
    { key: "tipo", label: "Tipo", type: "select", options: ["Metro", "Tram", "Autobus", "Treno locale"] },
    { key: "partenza", label: "Partenza", type: "text" },
    { key: "arrivo", label: "Arrivo", type: "text" },
    { key: "orario", label: "Orario", type: "time" },
    { key: "frequenza", label: "Frequenza", type: "text" },
    { key: "cambi", label: "Cambi", type: "text" },
    { key: "biglietto_app", label: "Biglietto / App", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "limitazioni", label: "Eventuali limitazioni", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ],
};

function TAXI_LIKE(servizio) {
  return [
    { key: "servizio", label: "Servizio", type: "text", defaultValue: servizio },
    { key: "punto_partenza", label: "Punto di partenza", type: "text" },
    { key: "punto_arrivo", label: "Punto di arrivo", type: "text" },
    { key: "data", label: "Data", type: "date" },
    { key: "ora", label: "Ora", type: "time" },
    { key: "prenotazione", label: "Prenotazione", type: "text" },
    { key: "costo", label: "Costo (€)", type: "number" },
    { key: "codice", label: "Codice", type: "text" },
    { key: "link", label: "Link", type: "text" },
    { key: "note", label: "Note", type: "textarea" },
  ];
}

export const HOTEL_SCHEMA = [
  { key: "tipo", label: "Tipologia", type: "select", options: ["Hotel", "Residence", "Appartamento", "Nessun pernottamento"] },
  { key: "struttura", label: "Struttura", type: "text" },
  { key: "indirizzo", label: "Indirizzo", type: "text" },
  { key: "numero_notti", label: "Numero notti", type: "number" },
  { key: "camera", label: "Camera", type: "select", options: ["Singola", "Doppia", "Doppia uso singola", "Suite"] },
  { key: "colazione", label: "Colazione inclusa", type: "checkbox" },
  { key: "parcheggio", label: "Parcheggio", type: "checkbox" },
  { key: "wifi", label: "Wi-Fi", type: "checkbox" },
  { key: "distanza_cliente", label: "Distanza dal cliente", type: "text" },
  { key: "distanza_fiera", label: "Distanza dalla fiera", type: "text" },
  { key: "distanza_stazione", label: "Distanza da stazione/metro", type: "text" },
  { key: "checkin", label: "Check-in", type: "text" },
  { key: "checkout", label: "Check-out", type: "text" },
  { key: "cancellazione_gratuita", label: "Cancellazione gratuita", type: "checkbox" },
  { key: "tassa_soggiorno", label: "Tassa di soggiorno (€)", type: "number" },
  { key: "costo", label: "Costo (€)", type: "number" },
  { key: "codice_prenotazione", label: "Codice prenotazione", type: "text" },
  { key: "link", label: "Link", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];

export const PARCHEGGIO_SCHEMA = [
  { key: "destinazione", label: "Destinazione", type: "select", options: ["Aeroporto", "Stazione", "Hotel", "Cliente / Fiera"] },
  { key: "nome", label: "Nome", type: "text" },
  { key: "indirizzo", label: "Indirizzo", type: "text" },
  { key: "tipo", label: "Tipo", type: "select", options: ["Coperto", "Scoperto", "Ufficiale", "Privato", "Valet", "Con navetta"] },
  { key: "prenotazione", label: "Prenotazione", type: "text" },
  { key: "data_ingresso", label: "Data ingresso", type: "date" },
  { key: "ora_ingresso", label: "Ora ingresso", type: "time" },
  { key: "data_uscita", label: "Data uscita", type: "date" },
  { key: "ora_uscita", label: "Ora uscita", type: "time" },
  { key: "costo", label: "Costo (€)", type: "number" },
  { key: "codice_prenotazione", label: "Codice prenotazione", type: "text" },
  { key: "link", label: "Link", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];

export const DESTINAZIONE_SCHEMA = [
  { key: "tipologia", label: "Tipologia", type: "select", options: ["Cliente", "Sede cliente", "Stabilimento", "Fiera", "Evento", "Corso", "Meeting", "Altra destinazione"] },
  { key: "nome", label: "Nome", type: "text" },
  { key: "indirizzo", label: "Indirizzo", type: "text" },
  { key: "referente", label: "Referente", type: "text" },
  { key: "telefono", label: "Telefono", type: "text" },
  { key: "email", label: "Email", type: "text" },
  { key: "orario_appuntamento", label: "Orario appuntamento", type: "time" },
  { key: "orario_ingresso", label: "Orario ingresso", type: "time" },
  { key: "registrazione", label: "Registrazione / Badge / Accredito", type: "text" },
  { key: "documenti", label: "Documenti necessari", type: "text" },
  { key: "parcheggio_disponibile", label: "Parcheggio disponibile", type: "checkbox" },
  { key: "note", label: "Note", type: "textarea" },
];

export const LOCALE_MEZZI = ["A piedi", "Metro", "Tram", "Autobus", "Treno locale", "Taxi", "Uber", "NCC", "Auto aziendale", "Auto a noleggio", "Auto propria"];

export const TRASPORTO_LOCALE_SCHEMA = [
  { key: "da", label: "Punto di partenza", type: "text" },
  { key: "a", label: "Punto di arrivo", type: "text" },
  { key: "mezzo", label: "Mezzo", type: "select", options: LOCALE_MEZZI },
  { key: "data", label: "Data", type: "date" },
  { key: "ora", label: "Ora", type: "time" },
  { key: "costo", label: "Costo (€)", type: "number" },
  { key: "prenotazione", label: "Prenotazione", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];

export const BOOKING_TIPI = ["Volo", "Treno", "Auto aziendale", "Auto a noleggio", "Parcheggio", "Hotel", "Taxi", "Uber", "NCC", "Trasporto locale", "Biglietti / ingressi"];

export const PRENOTAZIONE_SCHEMA = [
  { key: "tipo", label: "Tipo", type: "select", options: BOOKING_TIPI },
  { key: "fornitore", label: "Fornitore", type: "text" },
  { key: "data", label: "Data", type: "date" },
  { key: "ora", label: "Ora", type: "time" },
  { key: "codice", label: "Codice prenotazione", type: "text" },
  { key: "costo", label: "Costo (€)", type: "number" },
  { key: "link", label: "Link", type: "text" },
  { key: "documento", label: "Conferma / Documento", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];

export const SERVIZI_TIPI = ["Bagaglio extra", "Scelta posto", "Assicurazione", "Navetta", "Taxi", "Uber", "NCC", "Parcheggio", "Biglietto fiera", "Accredito evento", "Iscrizione evento", "Sala riunioni", "Catering / pasti", "Altri servizi"];

export const SERVIZIO_SCHEMA = [
  { key: "tipo", label: "Tipo servizio", type: "select", options: SERVIZI_TIPI },
  { key: "costo", label: "Costo (€)", type: "number" },
  { key: "note", label: "Note", type: "textarea" },
];

export const CONSIGLI_SCHEMA = [
  { key: "percorso_consigliato", label: "Percorso consigliato", type: "textarea" },
  { key: "durata", label: "Durata", type: "text" },
  { key: "mezzo_consigliato", label: "Mezzo consigliato", type: "text" },
  { key: "orario_partenza_consigliato", label: "Orario partenza consigliato", type: "time" },
  { key: "anticipo_aeroporto", label: "Anticipo consigliato aeroporto", type: "text" },
  { key: "anticipo_stazione", label: "Anticipo consigliato stazione", type: "text" },
  { key: "dove_acquistare_biglietto", label: "Dove acquistare il biglietto", type: "text" },
  { key: "app_utile", label: "App utile", type: "text" },
  { key: "ztl", label: "Attenzione ZTL / aree pedonali", type: "text" },
  { key: "taxi_ufficiali", label: "Taxi ufficiali", type: "text" },
  { key: "scioperi", label: "Scioperi / interruzioni", type: "text" },
  { key: "alternativa_problemi", label: "Alternativa in caso di problemi", type: "textarea" },
  { key: "contatti_utili", label: "Contatti utili", type: "textarea" },
  { key: "info_particolari", label: "Informazioni particolari sulla destinazione", type: "textarea" },
];

export const PREVENTIVO_VOCI = [
  { key: "trasporto", label: "Trasporto" },
  { key: "parcheggio", label: "Parcheggio" },
  { key: "hotel", label: "Hotel" },
  { key: "noleggio", label: "Noleggio" },
  { key: "taxi_uber_ncc", label: "Taxi / Uber / NCC" },
  { key: "trasporto_locale", label: "Trasporto locale" },
  { key: "biglietti", label: "Biglietti / ingressi" },
  { key: "altri_servizi", label: "Altri servizi" },
];

export function euro(n) {
  const v = Number(n || 0);
  return v.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}

export function formatDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d;
  }
}

export const SOLUZIONE_VOLO_SCHEMA = [
  { key: "aeroporto_partenza", label: "Aeroporto di partenza", type: "select", options: AEROPORTI_PREFERITI, allowCustom: true },
  { key: "aeroporto_arrivo", label: "Aeroporto di arrivo", type: "text" },
  { key: "data_partenza", label: "Data partenza", type: "date" },
  { key: "ora_partenza", label: "Ora partenza", type: "time" },
  { key: "data_arrivo", label: "Data arrivo", type: "date" },
  { key: "ora_arrivo", label: "Ora arrivo", type: "time" },
  { key: "diretto", label: "Volo diretto", type: "checkbox" },
  { key: "scali", label: "Eventuali scali", type: "text" },
  { key: "compagnia", label: "Compagnia", type: "text" },
  { key: "bagaglio", label: "Bagaglio", type: "text" },
  { key: "prezzo", label: "Prezzo (€)", type: "number" },
  { key: "riferimento", label: "Riferimento / prenotazione", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];

export const SOLUZIONE_HOTEL_SCHEMA = [
  { key: "struttura", label: "Struttura", type: "text" },
  { key: "indirizzo", label: "Indirizzo", type: "text" },
  { key: "notti", label: "Numero notti", type: "number" },
  { key: "camera", label: "Camera", type: "select", options: ["Singola", "Doppia", "Doppia uso singola", "Suite"] },
  { key: "colazione", label: "Colazione inclusa", type: "checkbox" },
  { key: "prezzo", label: "Prezzo (€)", type: "number" },
  { key: "riferimento", label: "Riferimento / prenotazione", type: "text" },
  { key: "note", label: "Note", type: "textarea" },
];
